// Ported verbatim from vue3/src/features/customer-display/ratingChoices.js
// (pure, framework-independent - see format.js's header for why this is
// duplicated rather than moved into shared/). Named ratingChoiceOptions.js
// here, not ratingChoices.js like the Vue 3 original, because that name
// collides with RatingChoices.vue on a case-insensitive filesystem (Windows)
// under Jest's default resolver -- found the hard way: `import ... from
// './ratingChoices'` silently resolved to the .vue component instead.
export const RATING_CHOICES = [
  { value: 1, emoji: '😞', label: 'ควรปรับปรุง' },
  { value: 2, emoji: '😐', label: 'พอใช้' },
  { value: 3, emoji: '😄', label: 'ดีมาก' }
];

export function emojiForRating(rating) {
  const choice = RATING_CHOICES.find((item) => item.value === rating);
  return choice ? choice.emoji : '';
}
